(() => {
  if (customElements.get('cdb-delivery-selector')) return;
  class DeliverySelector extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.date = this.querySelector('[data-delivery-date]');
      this.time = this.querySelector('[data-delivery-time]');
      this.flag = this.querySelector('[data-delivery-flag]');
      this.status = this.querySelector('[data-delivery-status]');
      this.save = this.querySelector('[data-delivery-save]');
      this.ja = this.dataset.ja === 'true';
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Tokyo', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
      const part = type => parts.find(p => p.type === type).value;
      const today = Date.UTC(Number(part('year')), Number(part('month')) - 1, Number(part('day')));
      for (let days = 5; days <= 30; days++) {
        const value = new Date(today + days * 86400000).toISOString().slice(0,10);
        this.date.add(new Option(value, value));
      }
      this.savedDate = this.dataset.date || '';
      this.savedTime = this.dataset.time || '時間帯指定なし';
      this.date.value = this.savedDate;
      this.time.value = this.savedTime;
      this.invalidSaved = this.date.selectedIndex < 0 || this.time.selectedIndex < 0;
      if (this.date.selectedIndex < 0) this.date.value = '';
      if (this.time.selectedIndex < 0) this.time.value = '時間帯指定なし';
      this.date.disabled = this.time.disabled = false;
      // The parent cart treats every bubbled change as a quantity update.
      this.addEventListener('change', event => { event.stopPropagation(); this.update(); });
      this.querySelector('form').addEventListener('submit', () => {
        this.flag.value = this.date.value ? 'あり' : 'なし';
        this.status.textContent = this.ja ? '配送希望を保存しています…' : 'Saving delivery preferences…';
      });
      this.guard = event => {
        if (!this.dirty || !event.target.closest('[name="checkout"], a[href*="/checkout"]')) return;
        event.preventDefault(); event.stopImmediatePropagation(); this.save.focus();
      };
      document.addEventListener('click', this.guard, true);
      this.submitGuard = event => {
        if (this.dirty && event.target.id === 'cart') {
          event.preventDefault(); this.save.focus();
        }
      };
      document.addEventListener('submit', this.submitGuard, true);
      this.update();
      // Cart quantity updates can replace checkout controls without replacing this selector.
      this.observer = new MutationObserver(() => this.guardAccelerated());
      this.observer.observe(this.closest('cart-items'), {childList:true, subtree:true});
    }
    update() {
      this.dirty = this.invalidSaved || this.date.value !== this.savedDate || this.time.value !== this.savedTime;
      this.flag.value = this.date.value ? 'あり' : 'なし';
      this.save.disabled = !this.dirty;
      this.status.textContent = this.invalidSaved
        ? (this.ja ? '以前の指定日・時間帯は選択できません。ご希望を選び直して保存してください。' : 'Your previous preference is no longer available. Choose and save a new preference.')
        : this.dirty
          ? (this.ja ? '変更した配送希望を保存してから、ご購入手続きへお進みください。' : 'Save your updated preferences before proceeding to checkout.')
          : (this.ja ? '表示中の配送希望でご購入手続きへ進めます。' : 'You can proceed to checkout with the displayed preferences.');
      this.guardAccelerated();
    }
    guardAccelerated() {
      this.closest('cart-items').querySelectorAll('.additional-checkout-buttons').forEach(el => {
        // Avoid an accelerated checkout losing preferences that have not been saved.
        el.hidden = this.dirty;
        el.style.display = this.dirty ? 'none' : '';
      });
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.guard, true);
      document.removeEventListener('submit', this.submitGuard, true);
      this.observer?.disconnect();
    }
  }
  customElements.define('cdb-delivery-selector', DeliverySelector);
})();
